<div class="container text-left">
  <mat-toolbar class="titulo">Detalhes do Ofício</mat-toolbar>
  <div class="container text-left">
    <mat-card class="card" *ngIf="ordem">
      <div class="row dados-titulo">
        <p class="col-md-12" [attr.data-cy]="'numero-solicitacao'"><b>Número da Solicitação:</b> {{ getNroSolicitacao() }}</p>
        <p class="col-md-6" [attr.data-cy]="'numero-processo'"><b>Número do Processo:</b> {{ ordem.numeroProcesso | mask: '0000000-00.0000.0.00.0000'}}</p>
        <p class="col-md-6" [attr.data-cy]="'prazo-atendimento'"><b>Prazo de Atendimento:</b> {{ getDiasSla() }}</p>
      </div>
      <h3 class="subtitulo">Dados do Processo</h3>
      <div class="row dados-oficio">
        <p class="col-md-6" [attr.data-cy]="'criado-por'"><b>Criado por:</b> {{ ordem.cadastrador.nome }}</p>
        <p class="col-md-6" [attr.data-cy]="'tipo-ordem'"><b>Tipo da Ordem:</b> {{ ordem.tipoOrdem | tipoOrdem }}</p>
        <p class="col-md-6" [attr.data-cy]="'foro'"><b>Foro:</b> {{ ordem.foro.nome }}</p>
        <p class="col-md-6" [attr.data-cy]="'comarca'"><b>Comarca:</b> {{ ordem.praca?.nome }}</p>
        <p class="col-md-6" [attr.data-cy]="'orgao'"><b>Órgão:</b> {{ ordem.orgao?.nome }}</p>
        <p class="col-md-6" [attr.data-cy]="'uf'"><b>UF:</b> {{ ordem.praca?.uf }}</p>
        <p [class]="isTipoOrdem('ACAO') ? 'col-md-6' : 'col-md-12'" [attr.data-cy]="'status-ordem'"><b>Status da Ordem:</b> {{ ordem.status | statusOrdem }}</p>
        <p class="col-md-6" *ngIf="isTipoOrdem('ACAO')" [attr.data-cy]="'valor'"><b>Valor:</b> {{ formatValor(ordem.dadosOrdem.valorAnotacao) }}</p>
        <p class="col-md-6" [attr.data-cy]="'autor'"><b>Autor:</b> {{ ordem.dadosOrdem.nomeAutor ? ordem.dadosOrdem.nomeAutor : '--' }}</p>
        <p class="col-md-6" [attr.data-cy]="'reu'"><b>Réu:</b> {{ ordem.dadosOrdem.nomeReu ? ordem.dadosOrdem.nomeReu : '--' }}</p>
        <p class="col-md-12" *ngIf="isTipoOrdem('HISTORICO')">
          <b [attr.data-cy]="'periodo-historico'">Período do Histórico:</b> {{ getPeriodoHistorico(ordem) }} ano(s)
        </p>
        <div class="col-md-12" *ngIf="hasMotivoCancelamento()">
          <h3 class="subtitulo">Motivo de cancelamento</h3>
          <p [attr.data-cy]="'motivo-cancelamento'"> {{ ordem.motivoCancelamento }} </p>
        </div>
        <div class="col-md-12" *ngIf="ordem.titulares && ordem.titulares.length">
          <h3 class="subtitulo">{{ getTituloByTipoOrdem() }}</h3>
          <div class="row" *ngFor="let titular of ordem.titulares">
            <p class="col-md-6" [attr.data-cy]="'titular-nome-' + titular.documento"><b>Nome:</b> {{ titular.nome }}</p>
            <p class="col-md-6" [attr.data-cy]="'titular-documento-' + titular.documento"><b>Documento:</b> {{ titular.documento | mask: isPessoaFisica(titular.documento) ? '000.000.000-00' : '00.000.000/0000-00' }}</p>
          </div>
        </div>
        <div class="col-md-12" *ngIf="isTipoOrdem('BAIXA')">
          <h3 class="subtitulo">Credores</h3>
          <div class="row" *ngFor="let credor of ordem.dadosOrdem.credores">
            <p class="col-md-12" [attr.data-cy]="'credor-nome-' + credor.documento"><b>Nome:</b> {{ credor.nome }}</p>
            <p class="col-md-6" [attr.data-cy]="'credor-valor-' + credor.documento"><b>Valor da dívida:</b> {{ formatValor(credor.valor) }}</p>
            <p class="col-md-6" [attr.data-cy]="'credor-data-divida-' + credor.documento"><b>Data da dívida:</b> {{ credor.dataDivida | date:'dd/MM/yyyy' }}</p>
            <p class="col-md-6" *ngIf="credor.documento" [attr.data-cy]="'credor-documento-' + credor.documento"><b>Documento:</b> {{ credor.documento | mask: isPessoaFisica(credor.documento) ? '000.000.000-00' : '00.000.000/0000-00' }}</p>
            <p class="col-md-6" *ngIf="credor.numeroContrato" [attr.data-cy]="'credor-numero-contrato-' + credor.documento"><b>Número do contrato:</b> {{ credor.numeroContrato }}</p>
            <br><br>
          </div>
        </div>
        <div class="col-md-12 arquivo-anexo" *ngIf="hasAnexo(ordem)">
          <p [attr.data-cy]="'arquivo-anexado'"><b>Arquivo Anexado:</b> {{ ordem.dadosOrdem.arquivo.nomeArquivo }}</p>
          <button matSuffix class="download-btn" (click)="downloadArquivo()" mat-raised-button [attr.data-cy]="'button-download-arquivo'">
            <img id="u653_img" src="../../../../assets/images/ordens_cadastradas/u653.png" alt="Ícone de download">
            Download
          </button>
        </div>
        <div class="col-md-12" *ngIf="hasDescricao()">
          <h3 class="subtitulo">Descrição</h3>
          <p [attr.data-cy]="'descricao-ordem'"> {{ ordem.dadosOrdem.descricaoOrdem }} </p>
        </div>
      </div>
    </mat-card>
    <div class="row ">
      <div class="col-md-10"></div>
      <div class="col-sm-2">
        <button mat-raised-button class="btn btn-azul btn-block" (click)="voltar()" [attr.data-cy]="'button-voltar'">
          Voltar
        </button>
      </div>
    </div>
  </div>
</div>
